import(/* webpackMode: "eager" */ "/builds/JohnLewisPartnership/digital/services/money-web/money-web-ui/src/app/global-error.tsx");
